export interface ConversationWorkflowModel {
  workflowTemplateId: number;
}
